import CompactIcon from "../../assets/product-list-assets/compact.svg";
import type { ProductListGroup } from "../../types";

export const compact: ProductListGroup = {
  id: "compact",
  title: "productListGroup.compact.title",
  icon: {
    src: CompactIcon,
    width: 16,
    height: 21,
  },
};
